<app-dialog-header [title]="title" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="p-24" fxLayout="column" fxLayoutAlign="start">
    <ng-container *ngIf="isLoading; else loadedContent">
        <div class="mat-elevation-z2">
            <div class="move-dialog-shimmer-row" fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let row of shimmerRows">
                <div fxLayout="row" fxLayoutAlign="start center">
                    <div class="move-dialog-shimmer-dot animate mr-8"></div>
                    <div class="move-dialog-shimmer-avatar animate mr-8" *ngIf="showAvatar"></div>
                    <div class="move-dialog-shimmer-text animate"></div>
                </div>
                <div class="move-dialog-shimmer-button animate"></div>
            </div>
        </div>
    </ng-container>

    <ng-template #loadedContent>
        <div class="mat-elevation-z2" *ngIf="hasContent; else noTeams">
            <div
                *ngIf="allowMoveToRoot"
                fxLayout="row"
                fxLayoutAlign="space-between center"
                class="move-dialog-root-row w-100-p p-16 pr-24"
            >
                <div fxLayout="row" fxLayoutAlign="start center">
                    <span class="move-dialog-toggle-spacer mr-8 inline-flex items-center justify-center">
                        <span class="move-dialog-leaf-dot"></span>
                    </span>
                    <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center" *ngIf="showAvatar">
                        <mat-icon svgIcon="team"></mat-icon>
                    </div>
                    <h3>{{ 'TEAMS.SEARCH.LABEL.NO_PARENT_TEAM' | translate }}</h3>
                </div>

                <app-flat-button
                    [label]="'GENERAL.BUTTON.SELECT'"
                    (onClick)="onSelectRoot()"
                    [disabled]="selectedNode && !isRootSelected"
                    *ngIf="!isRootSelected; else unselectRoot"
                ></app-flat-button>

                <ng-template #unselectRoot>
                    <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselectRoot()"></app-white-button>
                </ng-template>
            </div>

            <mat-tree
                [dataSource]="dataSource"
                [treeControl]="treeControl"
                class="example-tree"
                [class.move-dialog-tree-under-root]="allowMoveToRoot"
                *ngIf="listTree?.length"
            >
                <!-- This is the tree node template for leaf nodes -->
                <!-- There is inline padding applied to this node using styles.
          This padding value depends on the mat-icon-button width. -->
                <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="w-100-p p-16 pr-24">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <span class="move-dialog-toggle-spacer mr-8 inline-flex items-center justify-center">
                                <span class="move-dialog-leaf-dot"></span>
                            </span>
                            <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center" *ngIf="showAvatar">
                                <mat-icon svgIcon="team"></mat-icon>
                            </div>
                            <h3>{{ node.name }}</h3>
                        </div>

                        <div *ngIf="node.isSelectable !== false">
                            <app-flat-button
                                [label]="'GENERAL.BUTTON.SELECT'"
                                (onClick)="onSelect(node)"
                                [disabled]="node.isBlockedDestination || (selectedNode && selectedNode.id !== node.id)"
                                *ngIf="!node.isSelected; else unselect"
                            ></app-flat-button>

                            <ng-template #unselect>
                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselect(node)"></app-white-button>
                            </ng-template>
                        </div>
                    </div>
                </mat-tree-node>
                <!-- This is the tree node template for expandable nodes -->
                <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                    <div fxLayout="row" fxLayoutAlign="space-between center" class="mat-tree-node p-16 pr-24">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <button mat-icon-button class="mr-8" (click)="toggleNode(node)" [attr.aria-label]="'Toggle ' + node.name">
                                <mat-icon class="mat-icon-rtl-mirror">
                                    {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
                                </mat-icon>
                            </button>
                            <div class="custom-avatar-icon mr-8" fxLayoutAlign="center center" *ngIf="showAvatar">
                                <mat-icon svgIcon="team"></mat-icon>
                            </div>
                            <h3>{{ node.name }}</h3>
                        </div>

                        <div *ngIf="node.isSelectable !== false">
                            <app-flat-button
                                [label]="'GENERAL.BUTTON.SELECT'"
                                (onClick)="onSelect(node)"
                                [disabled]="node.isBlockedDestination || (selectedNode && selectedNode.id !== node.id)"
                                *ngIf="!node.isSelected; else unselect"
                            ></app-flat-button>

                            <ng-template #unselect>
                                <app-white-button [label]="'GENERAL.BUTTON.UNSELECT'" (onClick)="onDeselect(node)"></app-white-button>
                            </ng-template>
                        </div>
                    </div>
                    <!-- There is inline padding applied to this div using styles.
                This padding value depends on the mat-icon-button width.  -->
                    <div [class.example-tree-invisible]="!treeControl.isExpanded(node)" role="group">
                        <div *ngIf="node.isLoading">
                            <div class="move-dialog-shimmer-row" fxLayout="row" fxLayoutAlign="space-between center" *ngFor="let row of childShimmerRows">
                                <div fxLayout="row" fxLayoutAlign="start center">
                                    <div class="move-dialog-shimmer-dot animate mr-8"></div>
                                    <div class="move-dialog-shimmer-avatar animate mr-8" *ngIf="showAvatar"></div>
                                    <div class="move-dialog-shimmer-text animate"></div>
                                </div>
                                <div class="move-dialog-shimmer-button animate"></div>
                            </div>
                        </div>
                        <ng-container matTreeNodeOutlet></ng-container>
                    </div>
                </mat-nested-tree-node>
            </mat-tree>
        </div>

        <ng-template #noTeams>
            <div fxLayout="column" fxLayoutAlign="center center" class="p-32">
                <mat-icon class="participant-view-illustration" svgIcon="team_illustration"></mat-icon>
                <h3 class="mt-8 mb-16">
                    {{ 'TEAMS.DIALOG.MOVE_TO.NO_TEAMS' | translate }}
                </h3>
            </div>
        </ng-template>
    </ng-template>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button [disabled]="!selectedNode || isLoading" [label]="'GENERAL.LABEL.CLEAR_SELECTION'" (onClick)="onClearSelection()"></app-white-button>

    <div class="example-spacer"></div>
    <app-white-button class="mr-8" [label]="'GENERAL.BUTTON.CANCEL'" (onClick)="dialogRef.close(false)"></app-white-button>
    <app-flat-button [label]="'GENERAL.BUTTON.SAVE'" (onClick)="onSave()" [disabled]="!selectedNode || isLoading"></app-flat-button>
</div>
